import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { FC } from 'react';
import { ControlledSelectInput } from 'Components/ControlledSelectInput';
import { IFormMetaData } from 'API';
import { Stack } from '@mui/material';
import { useIsDesktop } from 'Hooks';

export interface ISelectRequestType {
  value: string;
  onChange: (value: string) => void;
  uploadFilesList?: IFormMetaData;
  errorMsg?: string;
}
export const SelectRequestType: FC<ISelectRequestType> = ({
  value,
  onChange,
  uploadFilesList,
  errorMsg,
}) => {
  const dictionary = Dictionary[DICTIONARY.UniversalRequest].uploadFile;
  const isDesktop = useIsDesktop();
  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='center'
      spacing={2}
      mb={isDesktop ? 3 : 0}
    >
      <ControlledSelectInput
        label={dictionary.fileType}
        options={
          uploadFilesList?.attachments
            ? uploadFilesList?.attachments.map((item) => item.name)
            : []
        }
        optionsValues={
          uploadFilesList?.attachments
            ? uploadFilesList?.attachments.map((item) => item.id)
            : []
        }
        value={
          uploadFilesList?.attachments &&
          uploadFilesList.attachments.length === 1
            ? uploadFilesList?.attachments[0].id
            : value
        }
        defaultValue={
          uploadFilesList?.attachments &&
          uploadFilesList.attachments.length === 1
            ? uploadFilesList.attachments[0].id // Set the default value for single option
            : undefined // No default value if there are multiple options
        }
        setValue={onChange}
        sx={{
          width: '100% !important',

          '& .MuiOutlinedInput-root': {
            backgroundColor: isDesktop ? undefined : '#fff',
            borderRadius: isDesktop ? undefined : '8px',
          },
        }}
        errorMsg={errorMsg}
        formControlProps={{
          ['aria-invalid']: errorMsg ? true : false,
          ['aria-required']: true,
        }}
      />
    </Stack>
  );
};
